import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormGroup, FormBuilder,FormArray } from '@angular/forms';
import { kpiBulkCopy, kpiband, kpiWithTarget } from './../../../models/slakpi';
import { UtilityService } from './../../../services/utility.service';
import { SLAKPIApiService } from './../../../services/slakpi.service';
import { UserService } from './../../../services/user.service';
import { SpinnerVisibilityService } from 'ng-http-loader';  
import Swal from 'sweetalert2'; 
import { Router, ActivatedRoute, Params } from '@angular/router';
import { year } from './../../../models/slakpi';
import { uniqBy } from 'lodash';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  OnEventArgs,

} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToasterService } from '../../../toaster.service';
import { isNullOrUndefined } from 'util';
@Component({
  selector: 'app-kpi-band',
  templateUrl: './kpi-band.component.html',
  styleUrls: ['./kpi-band.component.css']
})
export class KPIBandComponent implements OnInit {
  columnDefinitions: Column[];
  public data: any;
  public kpiData: object[];
  public kpiBand: kpiband[];
  public editSettings: Object;
  public filterSettings: Object;
  public toolbar: string[];
  public pageSettings: Object;
  public formatoptions: Object;
  public pageAction: string = 'add';
  public submitClicked: boolean = false;
  public condition1_data: any;
  public condition2_data: any;
  public type_data: any;
  public selected_rule: any;
  public actualt_target: number;
  public actualt_target_full: number;
  public permission: number = 1;
  public defaultyear: number = 2019;
  public selected_kpiUno: number = 0;
  public kpiBandForm: FormGroup;
  public yearsArray: FormArray;
  public kpiUno_global: number;
  public Frequency_global: number;
  public argsRowdata_global: any;
  public targetValue_Max: number;

  public loading: boolean = true;
  public currentHalf: number = 1;
  public currentQuarter: number = 1;
  public currentMonth: number = 1;
  public scheduleTypeUno: number = 0;
  user: any = {};
  login_UserID: string; // number

  //for Users Permission
  public permision_add: boolean = false;
  public permision_edit: boolean = false;
  public permision_delete: boolean = false;
  angularGrid: AngularGridInstance;
  isAdmin: boolean = false;
  gridOptions: GridOption;
  dataset: any;
  //for the buld process
  public position_chart: object = { X: 570, Y: 150 };
 
  public CurrentyearText: string = '';
  public quaterData: any;
  public destinationData: any;
  public Bulk_Type: any;
  public Bulk_Source: any;
  public Bulk_Target: any;
  public frequency_data: any;
  public isProgress: boolean = false
  public yearUno?: number;
  public isDataEntryError: boolean = false;
  public txtDataEntryError: string = '';

  public yearUno_start: number;
  public yearUno_end: number;
  public yearData: any;
  @ViewChild('editSettingsTemplate', { static: false }) editTemplate: TemplateRef<any>;
  @ViewChild('KPIBulkUpdateDialog', { static: false }) copyTemplate: TemplateRef<any>;
  modalRef: BsModalRef;
    headerText: string;
    searchText: string;
  dataSearch: any;
  noDataImg: any;
  tenantUno: any;
  constructor(public restApi: SLAKPIApiService, private modalService: BsModalService, private toaster: ToasterService,public utilityService: UtilityService, private router: Router, private userService: UserService, private spinner: SpinnerVisibilityService, private formBuilder: FormBuilder) {
    //To Validate User Permission
    this.user = this.userService.getUserInfo();
    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;
    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'SLA Admin' || this.user.role == 'DDAdmin' || this.user.role == 'DDAdminReadonly') ? true : false;
    if (!this.isAdmin) {
      this.CheckUserPermission();
    }
    else {
      this.permision_add = true;
      this.permision_edit = true;
      this.permision_delete = true;
      //User rights
     
    }
  }

  ngOnInit() {
    this.userService.CheckLogin();
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.defaultyear = this.user.currentYear;
    this.yearUno = this.user.currentYear;
    this.yearUno_start = this.yearUno;
    this.yearUno_end = this.yearUno;
    this.currentHalf = this.user.currentHalf;
    this.currentQuarter = this.user.currentQuarter;
    this.currentMonth = this.user.currentMonth;

    
    this.getConditions();
    this.getTypes();
    this.loadYear();

    setTimeout(() => {
      this.loadKPI();
    }, 500);
   
    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 100
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };
  }


  //To Validate Current User - Page Level Permission
  CheckUserPermission() {

    let userPermissionData = this.userService.getUserRights("KPI Band");
    if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
      if (userPermissionData[0].showPage == 1) {
        this.permision_add = (userPermissionData[0].showAdd == 1) ? true : false;
        this.permision_edit = (userPermissionData[0].showEdit == 1) ? true : false;
        this.permision_delete = (userPermissionData[0].showDelete == 1) ? true : false;
        
        //User rights
        this.editSettings = { allowEditing: this.permision_edit, mode: 'Dialog' };

        this.toolbar = this.userService.getRights_Toolbar_kpi_withoutexcel(this.permision_add, this.permision_edit, this.permision_delete);

      }
      else {
        this.router.navigateByUrl('/access-denied');
      }
    }
    else {
      this.router.navigateByUrl('/access-denied');
    }
  }
  showBulkProcessDialog() {
    this.CurrentyearText = this.user.currentYear.toString();
    this.frequency_data = [];
    this.getFrequency();
    this.quaterData = [];
    this.Bulk_Type = '';
    this.Bulk_Source = '';
    this.Bulk_Target = '';
    this.destinationData = [];
    this.modalRef = this.modalService.show(
      this.copyTemplate,
      Object.assign({}, {
        class: 'gray modal-xl modal-full',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true })
    );
  }
  getFrequency() {
    this.frequency_data = [
      { value: 2, displayText: 'Semi-annually' },
      { value: 3, displayText: 'Quarterly' },
      { value: 1, displayText: 'Annually' }
      //{ frequencyCode: 4, frequencyName: 'Monthly' }
    ];
  }
  loadQuater() {

    this.quaterData = [
      { value: 1, displayText: 'Q1' },
      { value: 2, displayText: 'Q2' },
      { value: 3, displayText: 'Q3' },
      { value: 4, displayText: 'Q4' }

    ];
  }
  loadYearDrp() {
    this.quaterData = [
      { value: 1, displayText: 'From Year' }


    ];
  }
  loadHalfQuater() {
    this.quaterData = [
      { value: 1, displayText: 'First Half' },
      { value: 2, displayText: 'Second Half' }

    ];
  }

  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  exportToExcel() {
    var temp = this;
    setTimeout(function () {
      temp.angularGrid.excelExportService.exportToExcel({
        filename: 'Export',
        format: FileType.xlsx,

      });
    }, 100)


  }


  Checklabel(val) {
    if (val  && val != '' && val != ' ')
      return val;
    else
      return ''

  }

  CheckValue(val) {
    if (val && val != '' && val != ':')
      return val;
    else
      return ' '

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val
      return val.toString().charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' '

  }
  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }
  searchGrid() {
    
    if (this.searchText != "") {
      this.dataset = this.dataSearch.filter(a =>
        a.kpiCode && a.kpiCode.toLowerCase().includes(this.searchText.toLowerCase())
        || (a.kpiNameEn && a.kpiNameEn.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.reportingDivisionName && a.reportingDivisionName.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.scheduleName && a.scheduleName.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.slaRuleName && a.slaRuleName.toLowerCase().includes(this.searchText.toLowerCase()))
        //|| (a.targetValue && a.targetValue.toLowerCase().includes(this.searchText.toLowerCase()))
      );
    }
    else
      this.dataset = this.dataSearch;
  }
  setColnDefn() {
    let temp = this;
    this.columnDefinitions = [
      {
        id: 'kpiCode', name: 'KPI Code', field: 'kpiCode', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'kpiCode', 'kpiCode'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'kpiNameEn', name: 'KPI', field: 'kpiNameEn', sortable: true, type: FieldType.string, filterable: true, width: 300,
        filter: {
          collection: this.uniqueArray(this.dataset, 'kpiNameEn', 'kpiNameEn'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'reportingDivisionName', name: 'Division', field: 'reportingDivisionName', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'reportingDivisionName', 'reportingDivisionName'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'slaRuleName', name: 'KPI Type', field: 'slaRuleName', selectable: false, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'slaRuleName', 'slaRuleName'),
          model: Filters.multipleSelect,
        }
      },
     
  
      {
        id: 'scheduleName', name: 'Schedule', field: 'scheduleName', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'scheduleName', 'scheduleName'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'targetValue', name: 'Target Value', field: 'targetValue', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'targetValue', 'targetValue'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'action', name: 'Action', field: 'action', width: 50, cssClass: 'blue',
        type: FieldType.string, formatter: (row, cell, val, columnDef, data) => { return '<span style="cursor:pointer"><i class="fa fa-pencil-square-o fa-lg"></i></span>'; },
        onCellClick: (e: Event, args: OnEventArgs) => {
          this.pageAction = 'edit';
          let objdata: any = args.dataContext;
          objdata = this.data.filter((items: any) => items.kpiUno == objdata.id)[0];
          

          if (this.permission == 1) {
            this.submitClicked = false;
            ;
            this.argsRowdata_global = objdata;
            this.createFormGroup(objdata);
            this.selected_rule = objdata.slaRuleUno;
            this.selected_kpiUno = (objdata.kpiUno != null && objdata.kpiUno != '') ? objdata.kpiUno : objdata.kpiUnoTemp;
            this.targetValue_Max = objdata.targetValue;
            this.actualt_target = (objdata.targetValue != null && objdata.targetValue != '') ? parseInt(objdata.targetValue) : 0;
            //this.actualt_target = (this.actualt_target >= 100) ? 100 : this.actualt_target;
            this.actualt_target_full = 100;
            if (objdata.scheduleUno == 1) { this.scheduleTypeUno = 19; }
            if (objdata.scheduleUno == 2) { this.scheduleTypeUno = 1; }
            if (objdata.scheduleUno == 3) { this.scheduleTypeUno = 3; }
            if (objdata.scheduleUno == 4) { this.scheduleTypeUno = 7; }
            this.headerText = 'Details of ' + objdata.kpiCode + " : " + objdata.kpiNameEn;
            this.addItem((objdata.kpiUno != null && objdata.kpiUno != '') ? objdata.kpiUno : objdata.kpiUnoTemp, objdata.scheduleUno);
            this.modalRef = this.modalService.show(
              this.editTemplate,
              Object.assign({}, {
                class: 'gray modal-xl modal-full',
                backdrop: true,
                keyboard: true,
                focus: true,
                show: false,
                ignoreBackdropClick: true,
                animated: true
              })
            );
          }
        }
      }
      //,{
      //  id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 50,
      //  excludeFromExport: true,
      //  formatter: this.actionFormatter,
      //  cellMenu: {
      //    hideCloseButton: false,
      //    commandTitleKey: 'COMMANDS',
      //    commandItems: [
      //      {
      //        command: 'edit-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Edit',
      //        iconCssClass: 'fa fa-pencil-square-o', cssClass: 'blue', textCssClass: 'bold',
      //        action: (e, args) => {
      //          this.pageAction = 'edit';
      //          let objdata: any = args.dataContext;
      //          objdata = this.data.filter((items: any) => items.kpiUno == objdata.id)[0];
      //          
                
      //          if (this.permission == 1) {
      //            this.submitClicked = false;
      //            ;
      //            this.argsRowdata_global = objdata;
      //            this.createFormGroup(objdata);
      //            this.selected_rule = objdata.slaRuleUno;
      //            this.selected_kpiUno = (objdata.kpiUno != null && objdata.kpiUno != '') ? objdata.kpiUno : objdata.kpiUnoTemp;
      //            this.targetValue_Max = objdata.targetValue;
      //            this.actualt_target = (objdata.targetValue != null && objdata.targetValue != '') ? parseInt(objdata.targetValue) : 0;
      //            this.actualt_target = (this.actualt_target >= 100) ? 100 : this.actualt_target;
      //            this.actualt_target_full = 100;
      //            if (objdata.scheduleUno == 1) { this.scheduleTypeUno = 19; }
      //            if (objdata.scheduleUno == 2) { this.scheduleTypeUno = 1; }
      //            if (objdata.scheduleUno == 3) { this.scheduleTypeUno = 3; }
      //            if (objdata.scheduleUno == 4) { this.scheduleTypeUno = 7; }
      //            this.headerText='Details of ' + objdata.kpiCode + " : " + objdata.kpiNameEn ;
      //            this.addItem((objdata.kpiUno != null && objdata.kpiUno != '') ? objdata.kpiUno : objdata.kpiUnoTemp, objdata.scheduleUno);
      //            this.modalRef = this.modalService.show(
      //              this.editTemplate,
      //              Object.assign({}, {
      //                class: 'gray modal-lg',
      //                backdrop: true,
      //                keyboard: true,
      //                focus: true,
      //                show: false,
      //                ignoreBackdropClick: true,
      //                animated: true
      //              })
      //            );
      //          }
      //        },
      //        // only show command to 'Delete Row' when the task is not completed

      //      },



      //    ],
      //  }
      //}




    ]


  }

  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
  };



  loadDestination() {
    
   
    if (this.Bulk_Source == 'Q1' || this.Bulk_Source == 'Q2' || this.Bulk_Source == 'Q3' || this.Bulk_Source == 'Q4') {
      this.destinationData = [
        { value: 1, displayText: 'Q1' },
        { value: 2, displayText: 'Q2' },
        { value: 3, displayText: 'Q3' },
        { value: 4, displayText: 'Q4' },
        { value: 5, displayText: 'Yearly' }
      ];
    }
    else {
      if (this.Bulk_Type == 'Annually') {
        this.destinationData = [
          { value: 1, displayText: 'To Year' }

        ];
      } else {
        this.destinationData = [
          { value: 1, displayText: 'First Half' },
          { value: 2, displayText: 'Second Half' },
          { value: 3, displayText: 'Yearly' }
        ];
      }
    }

  }
  onchangeFrequency(e) {
    
    this.Bulk_Type = (e.length > 0) ? e[0].text : 0;
    this.Bulk_Source= null;
    this.Bulk_Target = null;
    if (this.Bulk_Type == 'Quarterly') {
      this.loadQuater();
    }
    else if (this.Bulk_Type == 'Annually') {
      this.loadYearDrp();
    }
    else {
      this.loadHalfQuater();
    }
  }

  onchangeSource(e) {
    this.Bulk_Source = (e.length > 0) ? e[0].text : 0;
    this.destinationData = [];
    this.Bulk_Target = '';
    this.loadDestination();
  }

  onchangeTarget(e) {
    this.Bulk_Target = (e.length > 0) ? e[0].text : 0;
  }



  onBulkCopySubmit() {
    if (this.Bulk_Type == '' || this.Bulk_Source == '' || this.Bulk_Target == '') {
      this.isDataEntryError = true;
      this.txtDataEntryError = "Please select all the values to proceed the process."
      return;
    }
    else if (this.yearUno_start > this.yearUno_end) {
      this.isDataEntryError = true;
      this.txtDataEntryError = "The [Year From] should be less than or equal to [Year To]."
      return;
    }
    else {
      this.isDataEntryError = false;
      this.txtDataEntryError = "";
    }
    Swal.fire({
      title: 'Copy KPI Band',
      text: 'Please Confirm to Start the Copy KPI Band',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {

        this.spinner.show();
        let inpValue = new kpiBulkCopy();
        inpValue.yearFrom = this.yearUno_start;
        inpValue.yearTo = this.yearUno_end;
        inpValue.source = this.Bulk_Source;
        inpValue.target = this.Bulk_Target;
        inpValue.frequency = this.Bulk_Type;
        inpValue.tenantUno = this.tenantUno;
        inpValue.userUno = this.login_UserID;
        this.isProgress = true;
        
        this.restApi.bulkKPIBandProcess(inpValue)
          .subscribe(data => {
            
            this.spinner.hide();
            this.modalRef.hide();
            this.isProgress = false;
            //Swal.fire({
            //  type: 'success',
            //  title: 'KPI Bands successfully copied from ' + this.yearUno_start + '-' + this.Bulk_Source + ' to ' + this.yearUno_end + '-' + this.Bulk_Target + '.',
            //  showConfirmButton: false,
            //  timer: 1500
            //})
            this.toaster.show('success', 'Success', 'KPI Bands successfully copied from ' + this.yearUno_start + '-' + this.Bulk_Source + ' to ' + this.yearUno_end + '-' + this.Bulk_Target + '.');
          },
            (error) => {

              //Called when error
              this.spinner.hide();
              this.isProgress = false;
              this.modalRef.hide();
              //Swal.fire({
              //  title: 'KPI Bands successfully copied from ' + this.yearUno_start + '-' + this.Bulk_Source + ' to ' + this.yearUno_end + '-' + this.Bulk_Target + '.',              
              //  showConfirmButton: false,
              //  timer: 1500
              //})
              this.toaster.show('success', 'Success', 'KPI Bands successfully copied from ' + this.yearUno_start + '-' + this.Bulk_Source + ' to ' + this.yearUno_end + '-' + this.Bulk_Target + '.');
            }
          ).add(() => {
            //Called when operation is complete (both success and error)
            this.spinner.hide();
          });

        return;
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        return;
      }
    })


  }
  // Get kpi list
  loadKPI() {
    this.spinner.show();
    let inpValue = new kpiWithTarget();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    inpValue.currentYear = this.defaultyear;
    inpValue.currentHalf = this.currentHalf;
    inpValue.currentQuarter = this.currentQuarter;
    inpValue.currentMonth = this.currentMonth;
    
    this.restApi.getKpiWithTarget(inpValue)
      .subscribe(data => {
        
        this.data = data;
        
        this.kpiData = uniqBy(data, 'kpiUno');
        const mockDataset = [];
        for (let i = 0; i < this.kpiData.length; i++) {
          mockDataset[i] = {
            id: this.data[i].kpiUno,
            kpiCode: this.data[i].kpiCode,
            kpiNameEn: this.data[i].kpiNameEn,
            reportingDivisionName: this.data[i].reportingDivisionName,
            scheduleName: this.data[i].scheduleName,
            slaRuleName: this.data[i].slaRuleName,
            targetValue: this.data[i].targetValue
          };
        }
        this.dataset = mockDataset;
        this.dataSearch = mockDataset;
        if (mockDataset.length > 0) {
          this.setColnDefn();
        }
        this.kpiData = this.data
        this.loading = false;
        this.spinner.hide()
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
       // this.spinner.hide();
      });
  }

  getConditions() {
    this.condition1_data = [
      { text: '>', value: 1 },
      { text: '>=', value: 2 },
      { text: '=', value: 3 },
      { text: '<', value: 4 },
      { text: '<=', value: 5 }
     
    

    ];
    this.condition2_data = [

      { text: '<', value: 4 },
      { text: '<=', value: 5 }

    ];
  }
  getTypes() {
    this.type_data = [
      { text: '#', value: 1 },
      { text: '%', value: 2 }

    ];
  }
  radioChange(eventtypeNumber: any) {
    
    this.scheduleTypeUno = eventtypeNumber;
    this.createFormGroup(this.argsRowdata_global);

    this.addItem(this.kpiUno_global, this.Frequency_global);
    return true;
  }
  createFormGroup(data1: any) {

    this.kpiBandForm = this.formBuilder.group({
      kpiUno: '',
      yearsArray: this.formBuilder.array([])
    });
  }
  createyearItem(objkpiband: kpiband): FormGroup {
    
    if (objkpiband.scheduleTypeUno != 0) {
      this.scheduleTypeUno = objkpiband.scheduleTypeUno;
    }
    return this.formBuilder.group({
      kpiUno: objkpiband.kpiUno,
      kpiYear: objkpiband.kpiYear,
      kpiYear_Text: objkpiband.kpiYear_Text,
      rule: objkpiband.rule,
      bandtype: (objkpiband.bandtype == null || objkpiband.bandtype == undefined || objkpiband.bandtype == 0) ? 1 : objkpiband.bandtype,
      band1Condition1: (objkpiband.band1Condition1 == 0) ? 1 : objkpiband.band1Condition1,
      band1Value1: objkpiband.band1Value1,
      band1Condition2: (objkpiband.band1Condition2 == 0) ? 1 : objkpiband.band1Condition2,
      band1Value2: objkpiband.band1Value2,
      band1wellperform: objkpiband.band1wellperform,

      band2Condition1: (objkpiband.band2Condition1 == 0) ? 1 : objkpiband.band2Condition1,
      band2Value1: objkpiband.band2Value1,
      band2Condition2: (objkpiband.band2Condition2 == 0) ? 1 : objkpiband.band2Condition2,
      band2Value2: objkpiband.band2Value2,
      band2wellperform: true,//objkpiband.band2wellperform,

      band3Condition1: (objkpiband.band3Condition1 == 0) ? 1 : objkpiband.band3Condition1,
      band3Value1: objkpiband.band3Value1,
      band3Condition2: (objkpiband.band3Condition2 == 0) ? 1 : objkpiband.band3Condition2,
      band3Value2: objkpiband.band3Value2,
      band3wellperform: objkpiband.band3wellperform,

      band4Condition1: (objkpiband.band4Condition1 == 0) ? 1 : objkpiband.band4Condition1,
      band4Value1: objkpiband.band4Value1,
      band4Condition2: (objkpiband.band4Condition2 == 0) ? 1 : objkpiband.band4Condition2,
      band4Value2: objkpiband.band4Value2,
      band4wellperform: objkpiband.band4wellperform,

      band5Condition1: (objkpiband.band5Condition1 == 0) ? 1 : objkpiband.band5Condition1,
      band5Value1: objkpiband.band5Value1,
      band5Condition2: objkpiband.band5Condition2,
      band5Value2: (objkpiband.band5Condition2 == 0) ? 1 : objkpiband.band5Condition2,
      band5wellperform: objkpiband.band5wellperform,

      scheduleTypeUno: objkpiband.scheduleTypeUno,
    });
  }
  addItem(kpiuno, Frequency, condition:any=null): void {
    this.kpiUno_global = kpiuno;
    this.Frequency_global = Frequency;
    this.yearsArray = this.kpiBandForm.get('yearsArray') as FormArray;
    this.spinner.show();
    let inpValue = new kpiband();
    inpValue.languageUno = 1033;
    inpValue.kpiUno = kpiuno;
    inpValue.kpiYear = this.defaultyear;
    inpValue.defaultYear = this.defaultyear;
    inpValue.defaultQuater = this.currentQuarter;
    inpValue.defaultMonth = this.currentMonth;
    inpValue.defaultSemiYear = this.currentHalf;
    inpValue.rule = Frequency;
    inpValue.itemUno = 0;
    inpValue.condition = !isNullOrUndefined(condition) ? condition : 2;
    inpValue.scheduleTypeUno = this.scheduleTypeUno;
    inpValue.userUno = this.login_UserID;
    inpValue.tenantUno = this.tenantUno;
    
    this.restApi.getKpiBands(inpValue)

      .subscribe(kpidata => {
        this.createFormGroup(null);
        this.yearsArray = this.kpiBandForm.get('yearsArray') as FormArray;
        for (var i = 0; i < 7; i++) {
          
          this.yearsArray.push(this.createyearItem(kpidata[i]));
        }
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });


  }

  //actionBegin(args: SaveEventArgs): void {
  //  
  //  if (args.requestType === 'beginEdit' || args.requestType === 'add') {
  //    this.pageAction = (args.requestType === 'beginEdit') ? 'edit' : 'add';

  //    if (this.permission == 1) {
  //      this.submitClicked = false;
  //      ;
  //      this.argsRowdata_global = args.rowData;
  //      this.createFormGroup(args.rowData);
  //      let objdata: any = args.rowData;
  //      this.selected_rule = objdata.slaRuleUno;
  //      this.selected_kpiUno = (objdata.kpiUno != null && objdata.kpiUno != '') ? objdata.kpiUno : objdata.kpiUnoTemp;
  //      this.targetValue_Max = objdata.targetValue;
  //      this.actualt_target = (objdata.targetValue != null && objdata.targetValue != '') ? parseInt(objdata.targetValue) : 0;
  //      this.actualt_target = (this.actualt_target >= 100) ? 100 : this.actualt_target;
  //      this.actualt_target_full = 100;
  //      if (objdata.scheduleUno == 1) { this.scheduleTypeUno = 19; }
  //      if (objdata.scheduleUno == 2) { this.scheduleTypeUno = 1; }
  //      if (objdata.scheduleUno == 3) { this.scheduleTypeUno = 3; }
  //      if (objdata.scheduleUno == 4) { this.scheduleTypeUno = 7; }
  //      this.addItem((objdata.kpiUno != null && objdata.kpiUno != '') ? objdata.kpiUno : objdata.kpiUnoTemp, objdata.scheduleUno);
       
  //    }
  //  }
  //  if (args.requestType === 'save') {
  //    
  //    this.submitClicked = true;
  //    if (this.kpiBandForm.valid) {
  //      args.data = this.kpiBandForm.value;

  //      if (!this.AddEditKPIBand(args.data)) {
  //        this.submitClicked = false;
  //        args.cancel = true;
  //      }
  //      this.submitClicked = false;
  //    } else {
  //      args.cancel = true;
  //      //this.submitClicked = false;
  //    }
  //  }

  //  if (args.requestType === 'delete') {

  //  }
  //}
  //actionComplete(args: DialogEditEventArgs): void {
  //  
  //  if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {

  //    // Set initail Focus
  //    if (args.requestType === 'beginEdit') {
  //      //(args.form.elements.namedItem('divisionUno') as HTMLInputElement).focus();
  //    }

  //    const dialog = args.dialog;
  //    let objdata: any = args.rowData;
  //    dialog.width = (this.selected_rule == '10') ? 1200 : 600;
  //    dialog.header = args.requestType === 'beginEdit' ? 'Details of ' + objdata.kpiCode + " : " + objdata.kpiNameEn : '';
  //  }

  //}
  saveBand() {
    this.submitClicked = true;
    if (this.kpiBandForm.valid) {
      this.AddEditKPIBand(this.kpiBandForm.value);
    }
  }
  AddEditKPIBand(data1: any) {
    if (this.kpiBandForm==null || this.kpiBandForm.invalid) {
      //Swal.fire('Error', 'Something went wrong', 'error')
      this.toaster.show('error', 'Error', 'Something went wrong');
      return false;
    }
    if (this.scheduleTypeUno <= 0) {
      //Swal.fire('Error', 'Schedule type option is mandatory', 'error')
      this.toaster.show('error', 'Error', 'Schedule type option is mandatory');
      return false;
    }
    
    //validate the range
    let isError = false;
    for (var i = 0; i < data1.yearsArray.length - 1; i++) {
      if (data1.yearsArray[i].band1Value1 > 0 && data1.yearsArray[i].band2Value1 > 0) {
        if (data1.yearsArray[i].band1Condition1 == 1) {
          if (data1.yearsArray[i].band1Value1 >= data1.yearsArray[i].band2Value1) {
            isError = true;
            data1.yearsArray[i].isError = true;
          }
          else {
            data1.yearsArray[i].isError = false;
          }
        }
        if (data1.yearsArray[i].band1Condition1 == 2) {
          if (data1.yearsArray[i].band1Value1 > data1.yearsArray[i].band2Value1) {
            isError = true;
            data1.yearsArray[i].isError = true;
          }
          else {
            data1.yearsArray[i].isError = false;
          }
        }
      }
    }

  /*  if (isError) {
      Swal.fire('Error', 'Please correct the input value', 'error')
      return false;
    }*/


    let objKPIBand = new kpiband();
    
    objKPIBand.listkpiBand = data1.yearsArray;
    objKPIBand.userUno = this.login_UserID;
    objKPIBand.kpiYear = this.defaultyear;
    objKPIBand.defaultYear = this.defaultyear;
    objKPIBand.defaultQuater = 1;
    objKPIBand.defaultMonth = 1;
    objKPIBand.defaultSemiYear = 1;
    objKPIBand.kpiUno = this.selected_kpiUno;
    objKPIBand.rule = this.selected_rule;
    objKPIBand.condition = 1;//(this.pageAction == "add") ? 0 : 1;
    
    objKPIBand.scheduleTypeUno = this.scheduleTypeUno;
    this.restApi.addKpiBand(objKPIBand)
      .subscribe(data => {
        

        if (data != null && data != undefined && data != '') {
          //Swal.fire('Error', 'Something went wrong', 'error')
          this.toaster.show('error', 'Error', 'Something went wrong');
        }
        else {
          this.submitClicked = false;
          //this.modalRef.hide();
          //Swal.fire({
          //  type: 'success',
          //  title: 'KPI Band saved.',
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          this.toaster.show('success', 'Success', 'KPI Band saved.');
          //this.loadKPI();
        }


        this.spinner.hide();
        return true;
      },
        (error) => {
          //Called when error
          this.spinner.hide();
          return true;
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
        return true;
      });
    return true;

  }


 

  // Get Year / Quater
  loadYear() {

    let inpValue = new year();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    inpValue.tenantUno = 1;
    inpValue.userUno = this.login_UserID;
    
    this.restApi.getYearMasterAll(inpValue)
      .subscribe(data => {
        
        this.yearData = data;
        //this.inpyeardata.addItem({ text: 'All', value: '0' }, 0);
        setTimeout(() => {
          //this.inpyeardata_start.value = Number(this.yearUno);// Number(this.yearUno);
          //this.inpyeardata_end.value = Number(this.yearUno);// Number(this.yearUno);
        }, 10);
      },
        (error) => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }

}
